var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Flex from "../../../components/templates/flex";
import { Icon } from "../../../components/icon/icon";
var IconWrapper = styled(Flex).attrs({
    padding: [2],
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
export default (function (_a) {
    var onClick = _a.onClick, name = _a.name;
    return (React.createElement(IconWrapper, { onClick: onClick },
        React.createElement(Icon, { name: name, color: "text", width: 8, height: 8 })));
});
var templateObject_1;
